<div style="padding:20px">
    <ul class="nav nav-tabs" style="margin: 10px;">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <a onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
        </li>
    </ul>

    <hr>
    <button (click)="deault();now='0';act='0'" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">新增Tag</button>
    <hr>
    <div class="accordion" id="accordionExample">
        <div *ngFor="let item of data; let i = index">
            <div class="card">
                <div class="card-header" [id]="'headingThree' + i">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" [attr.data-target]="'#collapseThree' + i" aria-expanded="false" aria-controls="collapseThree">
                            {{item.name}}
                        </button>
                    </h2>
                </div>
                <div [id]="'collapseThree' + i" class="collapse" [attr.aria-labelledby]="'headingThree' + i"  data-parent="#accordionExample">
                    <button  class="btn btn-info" data-toggle="modal" data-target=".bd-example-modal-lg"  style="margin: 10px;" *ngFor="let itemdetail of item.data; let ix = index" (click)="deault();now='0';act='1';tagview(itemdetail.id)">{{itemdetail.name}}</button>
                </div>
            </div>
        </div>
    </div>

    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    <div *ngIf="data.length==0">無資料</div>
</div>

<div *ngIf="edit_data" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static"  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{(act == '0')?'新增':'修改'}}</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body" [ngClass]="{'modal-content-blue': colorNum == 0, 'modal-content-default': colorNum != 0}">
                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">Tag類別</label>
                    <select class="form-control"
                        style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.type"
                        (change)="selectType()"
                    >
                        <ng-container>
                            <option default disabled value="-2">請選擇類型</option>
                            <option *ngFor="let item of type_list" [ngValue]="item.id">{{item.name}}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">Tag類型</label>
                    <select class="form-control"
                        style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.sid"
                    >
                        <ng-container>
                            <option default disabled value="-2">請選擇類型</option>
                            <option *ngFor="let item of category_list" [ngValue]="item.id">{{item.name}}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">名稱</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.name">
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.type == '1'">
                    <label class="col-sm-2 col-form-label">組合類別</label>
                    <mat-form-field>
                        <mat-label>選擇呈現類別</mat-label>
                        <mat-select [(ngModel)]="edit_data.composition" multiple>
                            <mat-option *ngFor="let item of tag_list_type" [value]="item.id">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.type == '1' && edit_data.composition">
                    <ng-container *ngFor="let item of tag_list_type;">
                        <button style="margin: 10px;" class="btn btn-primary" *ngIf="edit_data.composition.includes(item.id.toString())">{{ item.name }}</button>
                    </ng-container>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.type != '2' && edit_data.type != '1'">
                    <label class="col-sm-2 col-form-label">Tag屬性相關</label>
                    <select class="form-control"
                        style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.tables"
                        (change)="checktable(-2)"
                    >
                        <ng-container>
                            <option default disabled value="-2">請選擇類型</option>
                            <option *ngFor="let item of table_select" [ngValue]="item.value">{{item.name}}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.type != '2' && edit_data.type != '1'">
                    <label class="col-sm-2 col-form-label">Tag影響欄位</label>
                    <select class="form-control"
                        style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.field"
                        (change)="variable1_selectls()"
                    >
                        <ng-container>
                            <option default disabled value="-2">請選擇類型</option>
                            <option *ngFor="let item of field_select" [ngValue]="item.value">{{item.name}}</option>
                        </ng-container>
                    </select>
                </div>



                <div class="user_edit_block form-group" *ngIf="false">
                    <label class="col-sm-2 col-form-label">影響表名稱</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.tables" disabled>
                </div>

                <div class="user_edit_block form-group" *ngIf="false">
                    <label class="col-sm-2 col-form-label">影響欄位</label>
                    <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.field" disabled>
                </div>

                <div style="display: flex;justify-content: space-around;" *ngIf="edit_data.field != 'active_period'">

                    <div class="user_edit_block form-group" *ngIf="edit_data.type != '2'  &&  edit_data.type != '1' &&  !operation1fieldlist.includes(edit_data.field)">
                        <label>運算符號</label>
                        <select class="form-control"
                                style="width: 250px;display: inline-block;margin-left: 50px;"
                                [(ngModel)]="edit_data.operation1"
                        >
                            <ng-container>
                                <option *ngFor="let item of operation1_select" [ngValue]="item.value">{{item.name}}</option>
                            </ng-container>
                        </select>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="edit_data.type != '1' && edit_data.type != '2' && !variable1fieldlist.includes(edit_data.field)">
                        <label>條件一</label>
                        <select class="form-control"
                            style="width: 250px;display: inline-block;margin-left: 50px;"
                            [(ngModel)]="edit_data.variable1"
                        >
                            <ng-container>
                                <option default disabled value="-2">請選擇變數</option>
                                <option *ngFor="let item of variable1_select" [ngValue]="item.value">{{item.name}}</option>
                            </ng-container>
                        </select>
                        <p class="tips" style="color: cadetblue;">{{tips1}}</p>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="variable1fieldinputlist.includes(edit_data.field) && edit_data.type != '1'">
                        <label>條件一</label>
                        <input type="number" class="form-control"  style="display: inline-block;width: 220px;margin-left: 50px;" [(ngModel)]="edit_data.variable1" pattern="[0-9]*" min="0" (keydown)="preventNegative($event)">
                        <p class="tips" style="color: cadetblue;">{{tips1}}</p>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="variable1fielddatelist.includes(edit_data.field) && edit_data.type != '1'">
                        <label>條件一</label>
                        <input type="date" class="form-control"  style="display: inline-block;width: 220px;margin-left: 50px;" [(ngModel)]="edit_data.variable1">
                        <p class="tips" style="color: cadetblue;">{{tips1}}</p>
                    </div>

                </div>

                <div  style="display: flex;justify-content: space-around;" *ngIf="edit_data.field != 'active_period'">
                    <div class="user_edit_block form-group" *ngIf="edit_data.type != '2'  && edit_data.type != '1' && !operation1fieldlist.includes(edit_data.field)">
                        <label>運算符號</label>
                        <select class="form-control"
                            style="width: 250px;display: inline-block;margin-left: 50px;"
                            [(ngModel)]="edit_data.operation2"
                        >
                            <ng-container>
                                <option *ngFor="let item of operation2_select" [ngValue]="item.value">{{item.name}}</option>
                            </ng-container>
                        </select>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="edit_data.type != '1' &&  edit_data.type != '2' &&  !variable2fieldlist.includes(edit_data.field)">

                        <label>條件二</label>
                        <select class="form-control"
                            style="width: 250px;display: inline-block;margin-left: 50px;"
                            [(ngModel)]="edit_data.variable2"
                        >
                            <ng-container>
                                <option default disabled value="-2">請選擇變數</option>
                                <option *ngFor="let item of variable1_select" [ngValue]="item.value">{{item.name}}</option>
                            </ng-container>
                        </select>
                        <p class="tips" style="color: cadetblue;">{{tips2}}</p>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="variable2fieldinputlist.includes(edit_data.field) && edit_data.type != '1'">
                        <label>條件二</label>
                        <input type="number" class="form-control" style="display: inline-block;width: 220px;margin-left: 50px;" [(ngModel)]="edit_data.variable2"  pattern="[0-9]*" min="0" (keydown)="preventNegative($event)">
                        <p class="tips" style="color: cadetblue;">{{tips2}}</p>
                    </div>

                    <div class="user_edit_block form-group" *ngIf="variable2fielddatelist.includes(edit_data.field)  && edit_data.type != '1'">
                        <label>條件二</label>
                        <input type="date" class="form-control"  style="display: inline-block;width: 220px;margin-left: 50px;" [(ngModel)]="edit_data.variable2">
                        <p class="tips" style="color: cadetblue;">{{tips2}}</p>
                    </div>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.tables != '-2'  && edit_data.type != '1' && edit_data.tables != 'user' && edit_data.field != '-2'&& !daylist.includes(edit_data.field) ">
                    <label class="col-sm-2 col-form-label">幾天內</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.variable3"  pattern="[0-9]*" min="1" (keydown)="preventNegative($event)">
                </div>

                <div class="user_edit_block form-group">
                    <label  class="col-sm-2 col-form-label">條件關係</label>
                    <select class="form-control"
                        style="width: 250px;display: inline-block;"
                        [(ngModel)]="edit_data.mode"
                    >
                        <ng-container>
                            <option default disabled value="-2">請選擇條件關係</option>
                            <option *ngFor="let item of type_select" [ngValue]="item.value">{{item.name}}</option>
                        </ng-container>
                    </select>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.field == 'hot' ">
                    <label class="col-sm-3 col-form-label">熱門度取前幾名</label>
                    <input type="number" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_data.variable3"  pattern="[0-9]*" min="1" (keydown)="preventNegative($event)">
                    <p class="tips" style="color: cadetblue;">{{tips1}}</p>
                </div>

                <div class="accordion" id="accordionExample" style="margin-top: 20px;" *ngIf="user_tag.length > 0 || user_total > 0">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <h2 class="mb-0">
                                <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    符合該Tag用戶
                                    <!-- 後端回最新一列 tag_map 的名單；系統／組合 tag 只回前 300 筆預覽，總數看 user_total（2026-09-16） -->
                                    <small class="text-muted">共 {{user_total | number}} 人<span *ngIf="user_tag.length < user_total">，只列前 {{user_tag.length}} 筆</span><span *ngIf="user_list_dt">（名單時間 {{user_list_dt}}）</span></small>
                                </button>
                            </h2>
                        </div>

                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">
                                <div class="user_edit_block form-group">
                                    <ng-container *ngFor="let item of user_tag">
                                        <button style="margin: 10px;" class="btn btn-info" (click)="deletetag(item)" *ngIf="item.name != ''">{{ item.name }}</button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="user_edit_block form-group" *ngIf="edit_data.type == '2'">
                    <app-search (item)="callitem($event)"  (searchstr)="searchstr($event)"></app-search>
                </div>

                <div class="user_edit_block form-group">
                    <label class="col-sm-2 col-form-label">狀態</label>
                    <button [ngClass]="edit_data.status == 1?'btn-info':'btn-secondary'" (click)="edit_data.status = 1;changecolor(1);" class="btn modalbtn" style="margin-right: 10px;">啟用</button>
                    <button [ngClass]="edit_data.status == 0?'btn-danger':'btn-secondary'"  (click)="edit_data.status = 0;changecolor(0);" class="btn modalbtn">停用</button>
                </div>
                <div class="user_edit_block form-group"  *ngIf="act == '1'">
                    <button  (click)="deletetaglist(edit_data)" class="btn modalbtn btn-info" style="margin-right: 10px;" data-dismiss="modal">刪除</button>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button"  *ngIf="act == '0'" (click)="save(0)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                <button type="button"  *ngIf="act == '1'" (click)="save(1)"  class="btn btn-primary" data-dismiss="modal">修改</button>
                <button type="button"  (click)="init_list()" class="btn btn-danger" data-dismiss="modal">取消</button>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
